// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.signaling-servers .form__textfield[data-v-7c858ea6]{width:300px}.additional-top-margin[data-v-7c858ea6]{margin-top:1em !important}`, "",{"version":3,"sources":["webpack://./src/components/AdminSettings/SignalingServers.vue"],"names":[],"mappings":"AAEC,qDACC,WAAA,CAIF,wCACC,yBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
